module.exports = __webpack_public_path__ + "assets/img/logo-alt.00d74ee4.png";